<template>
  <div class="animated fadeIn">
    <Tables ref="tableGrid"
      :columns="[
        'Periodo Movimento',
        'Resultados Associados',
        'Margem de Contribuição Bruta'
      ]"
      :showTipFooter="false"
      v-on:Load="onLoad">
      <tr v-for="obj in this.objList" v-bind:key="obj.id">
        <TableColumn :IsText="true" :status="1" :value="obj.periodoMovimento" />
        <TableColumn :IsText="true" :status="1" :value="obj.resultadosAssociados ? 'R$ ' + obj.resultadosAssociados.toFixed(2).toString() : 'R$ 0,00'" />
        <TableColumn :IsText="true" :status="1" :value="obj.margemContribuicaoBruta ? 'R$ ' + obj.margemContribuicaoBruta.toFixed(2).toString() : 'R$ 0,00'" />
      </tr>
    </Tables>
  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading } from '@/shared/utils/UIHelper'
import MargemContribuicaoRepository from '@/shared/http/repositories/business/margemcontribuicao.js'

export default {
  name: 'MargemContribuicao',
  mixins: [ActionsForm],
  data () {
    return {
      document: null
    }
  },
  methods: {
    onLoad () {
      if (this.document) {
        this.onLoadMargemContribuicao(this.document)
      }
    },
    onLoadMargemContribuicao (document) {
      loading.push()
      this.document = document
      MargemContribuicaoRepository.Search(document, this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
        .then((response) => {
          this.onResultGrid(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/associate/tabs/margemcontribuicao.vue